export const MAX_EMAIL_THREAD_CHAT_MESSAGE_IDS = 200;
